
const { ccclass, menu, property, inspector } = cc._decorator;

/**
 * !#en Enum for PageView Indicator type
 * !#zh 页面视图指示器的类型
 */
export enum IndicatorType {
    COLOR = 0,
    SPRITE = 1,
}

@ccclass
@menu('UI/UPageViewIndicator')
export default class UPageViewIndicator extends cc.PageViewIndicator {

    @property(cc.SpriteFrame)
    public chooseFrame: cc.SpriteFrame

    @property({ type: cc.Enum(IndicatorType) })
    public indicatorType: IndicatorType = IndicatorType.COLOR


    _createIndicator() {
        //@ts-ignore
        let node = super._createIndicator()
        if(this.indicatorType == IndicatorType.SPRITE){
            var node1 = new cc.Node();
            var sprite1 = node1.addComponent(cc.Sprite);
            sprite1.spriteFrame = this.chooseFrame
            node1.parent = node
            node1.width = node.width;
            node1.height = node.height;
            node1.name = "choose"
            node1.active = false
        }
        return node
    }
    _changedState() {
        if (this.indicatorType == IndicatorType.COLOR) {
            //@ts-ignore
            super._changedState()
        } else {
            //@ts-ignore
            var indicators = this._indicators;
            if (indicators.length === 0) return;
            //@ts-ignore
            var idx = this._pageView._curPageIdx;
            if (idx >= indicators.length) return;
            for (var i = 0; i < indicators.length; ++i) {
                var node = indicators[i];
                let choose = node.getChildByName('choose')
                choose.active = i == idx
            }
        }
    }
}
